import styles from './TitleEditor.module.less';

function TitleEditor(props: { titleName: string }) {
  return <div className={`${styles['title-editor']}`}>{props.titleName}</div>;
}

export default TitleEditor;
